<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb :page-title="$t('view_invoice')" :icon="'user-check'" />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            v-if="userRole.role != 'Buyer'"
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("create_invoice") }}
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <invoice-datatable @id="setId"></invoice-datatable>
    </div>

    <invoice-addmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :closeAddEditModal="closeAddEditModal"
      @close-modal="closeAddEditModal"
    />
  </div>
</template>

<script>
import datatable from "../Invoice/Datatable";

export default {
  name: "User",
  components: {
    datatable,
  },
  data() {
    return {
      isAddEditModalActive: false,
      
    };
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.getFilterValue();
      this.reSetData();
    },
    setId(id) {
      this.active = 2;
      this.$emit("id",id);
    },
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
